import classNames from 'classnames/bind';
import Navigation from '../../components/Navigation';
import styles from './Enrollment.module.scss';
import Button from '../../components/Button';
import { setActiveStep } from '../../state/enrollment/enrollmentActions';
import { EnrollmentStep } from '../../state/enrollment/enrollmentModel';
import PathSelection from './PathSelection';
import EntityInfo from './EntityInfo';
import AccountAdmin from './AccountAdmin';
import { AccountAdminStep } from './AccountAdmin/AccountAdmin';
import Review from './Review';
import Complete from './Complete';
import UserInfo from '../UserInfo';
import Footer from '../../components/Footer';

const cx = classNames.bind(styles);

export interface EnrollmentProps {
  enrollmentSteps: EnrollmentStep[];
  activeStep: EnrollmentStep;
  activeStepIndex: number;
  setActiveStep: typeof setActiveStep;
}

const Enrollment = (props: EnrollmentProps) => {
  const { enrollmentSteps, activeStep, activeStepIndex, setActiveStep } = props;

  const saveAndContinue = () => {
    const nextStep: EnrollmentStep = enrollmentSteps[activeStepIndex + 1];
    if (nextStep) {
      setActiveStep(nextStep);
    }
  };

  const renderActiveStep = () => {
    switch (activeStep) {
      case EnrollmentStep.PATH_SELECTION:
        return <PathSelection />;
      case EnrollmentStep.ENTITY_INFORMATION:
        return <EntityInfo />;
      case EnrollmentStep.ACCOUNT_ADMINISTRATOR_1:
        return (
          <AccountAdmin
            key={AccountAdminStep.ONE}
            step={AccountAdminStep.ONE}
          />
        );
      case EnrollmentStep.ACCOUNT_ADMINISTRATOR_2:
        return (
          <AccountAdmin
            key={AccountAdminStep.TWO}
            step={AccountAdminStep.TWO}
          />
        );
      case EnrollmentStep.REVIEW:
        return <Review />;
      case EnrollmentStep.COMPLETE:
        return <Complete />;
      default:
        return (
          <div className={cx('enrollment__footer')}>
            <Button
              onClick={saveAndContinue}
              disabled={activeStepIndex === enrollmentSteps.length - 1}
            >
              Save & Continue
            </Button>
          </div>
        );
    }
  };

  return (
    <div className={cx('enrollment')}>
      <div className={cx('enrollment__wrapper')}>
        <UserInfo />
        <Navigation />
      </div>
      {renderActiveStep()}
      <Footer />
    </div>
  );
};

export default Enrollment;
